import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
const CouponOrderPage = loadable(() => pMinDelay(import('./CouponOrderPage'), 300), {
  fallback: <Loading />
});
const AsyncCouponOrder = props => {

  const pageConfig = {
    headerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'none',
    hideSmartBanner: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation app-present`
      }
    }
  };
  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <CouponOrderPage { ...props } />
    </ApplicationLayout>
  );
};
AsyncCouponOrder.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncCouponOrder;
